import { render, staticRenderFns } from "./OtcPayIcon.vue?vue&type=template&id=69a05850&scoped=true&"
import script from "./OtcPayIcon.vue?vue&type=script&lang=js&"
export * from "./OtcPayIcon.vue?vue&type=script&lang=js&"
import style0 from "./OtcPayIcon.vue?vue&type=style&index=0&id=69a05850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a05850",
  null
  
)

export default component.exports